import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchAutomations = ({ projectId, offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'automations',
        params: {
            projectId,
            offset,
            limit
        }
    })
    .then(response => ({
        hasMore: response.data.hasMore,
        items: response.data.automations.map(({ _id, ...props }) => {
            return {
                ...props,
                id: _id
            };
        })
    }))
    .catch(handleServerError);
}

export const createAutomation = ({ projectId, name, color, trigger, action }) => {
    return AjaxService({
        method: 'post',
        url: 'automations',
        data: {
            projectId,
            name,
            color,
            trigger,
            action
        }
    })
    .then(response => {
        if (response.data?.existing) {
            return Promise.reject(response.data);
        }

        return response.data?.automation;
    });
    // .catch(handleServerError);
}

export const fetchAutomation = automationId => {
    return AjaxService({
        method: 'get',
        url: `automations/${automationId}`
    })
    .then(response => validateResponse(response, 'id').data)
    .catch(handleServerError);
}

export const updateAutomation = (automationId, { projectId, name, color, trigger, action, disabled }) => {
    return AjaxService({
        method: 'put',
        url: `automations/${automationId}`,
        data: {
            projectId,
            name,
            color,
            trigger,
            action,
            disabled
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeAutomation = automationId => {
    return AjaxService({
        method: 'delete',
        url: `automations/${automationId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
